import { render, staticRenderFns } from "./AdditionalResponseData.vue?vue&type=template&id=61ec8cc3&"
import script from "./AdditionalResponseData.vue?vue&type=script&lang=ts&"
export * from "./AdditionalResponseData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports